(() => {
  const init = (root) => {
    if (root.dataset.vinylReady) return;
    root.dataset.vinylReady = 'true';
    const image = root.querySelector('.s2t-vinyl__image');
    root.querySelectorAll('[data-vinyl-image]').forEach(button => {
      button.addEventListener('click', () => {
        if (!image) return;
        image.src = button.dataset.vinylImage;
        image.removeAttribute('srcset');
        image.alt = button.dataset.vinylAlt;
        root.querySelectorAll('[data-vinyl-image]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      });
    });
    const notice = root.querySelector('[data-vinyl-processing]');
    const noticeCopy = notice.querySelector('[data-vinyl-processing-copy]');
    const autoOpenKey = 'upcartShouldOpenOnAddToCartBackgroundNetworkCall';
    let pendingFrame = null;
    let previousAutoOpen;
    let hadAutoOpen;
    let waitingTimer;
    let completionObserver;
    const hideNotice = () => {
      if (typeof notice.hidePopover === 'function' && notice.matches(':popover-open')) notice.hidePopover();
      notice.hidden = true;
    };
    const finish = () => {
      if (!pendingFrame) return;
      clearTimeout(waitingTimer);
      completionObserver.disconnect();
      // Restore the prior setting without overriding another integration's new value.
      if (window[autoOpenKey] === false) {
        if (hadAutoOpen) window[autoOpenKey] = previousAutoOpen;
        else delete window[autoOpenKey];
      }
      pendingFrame = null;
      hideNotice();
    };
    const onDesignerMessage = event => {
      const frame = document.querySelector('iframe.antigroDesignerIframe');
      if (!frame || event.source !== frame.contentWindow) return;
      // Never trust messages from other frames or unrelated origins.
      if (event.origin !== new URL(frame.src, location.href).origin) return;
      if (event.data?.type === 'close') { finish(); return; }
      if (event.data?.type !== 'acceptance' || pendingFrame) return;
      pendingFrame = frame;
      hadAutoOpen = Object.prototype.hasOwnProperty.call(window, autoOpenKey);
      previousAutoOpen = window[autoOpenKey];
      // UpCart's supported background-request switch leaves Antigro's cart write,
      // final-price verification and successful cart-page redirect untouched.
      window[autoOpenKey] = false;
      noticeCopy.textContent = 'Please keep this page open. Your cart will open when your sticker and its price are ready.';
      document.body.appendChild(notice);
      notice.hidden = false;
      if (typeof notice.showPopover === 'function') notice.showPopover();
      waitingTimer = setTimeout(() => {
        noticeCopy.textContent = 'This is taking longer than usual. Please keep this page open and avoid adding the sticker again. You can hide this message to check the builder or contact us for help.';
      }, 45000);
      completionObserver = new MutationObserver(() => {
        if (!frame.isConnected) finish();
      });
      completionObserver.observe(document.body, { childList: true, subtree: true });
    };
    notice.querySelector('[data-vinyl-processing-dismiss]').addEventListener('click', hideNotice);
    window.addEventListener('message', onDesignerMessage);
    window.addEventListener('pagehide', finish);
    document.addEventListener('shopify:section:unload', event => {
      if (!event.target.contains(root)) return;
      finish();
      notice.remove();
      window.removeEventListener('message', onDesignerMessage);
      window.removeEventListener('pagehide', finish);
    });
    const mount = root.querySelector('[data-vinyl-app]');
    const status = root.querySelector('[data-vinyl-status]');
    const sync = () => {
      const frame = mount.querySelector('iframe');
      if (!frame) return;
      frame.title = 'Choose your vinyl sticker size, quantity and shape';
      frame.addEventListener('load', () => { status.hidden = true; }, { once: true });
      status.hidden = true;
    };
    // Antigro owns injection, sizing, price calculation, the Next action and the designer.
    // Observe only the local mount; never replace its iframe or mutate its configuration.
    const observer = new MutationObserver(sync);
    observer.observe(mount, { childList: true });
    sync();
    setTimeout(() => {
      if (!mount.querySelector('iframe')) status.textContent = 'The sticker builder is taking longer to load. Refresh this page or use the help link below.';
    }, 20000);
    root.querySelectorAll('a[href="#vinyl-builder"]').forEach(link => {
      link.addEventListener('click', () => {
        const panel = root.querySelector('#vinyl-builder');
        requestAnimationFrame(() => panel.focus({ preventScroll: true }));
      });
    });
  };
  document.querySelectorAll('[data-vinyl-page]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-vinyl-page]').forEach(init));
})();
